import React from "react";
import { connect } from "react-redux";
import { newSeasonFilterStyle } from "../../../services/utils";
import ReactSelect, { components } from "react-select";
import { setActivitiesOrder } from "../../../actions/actions/eventStats";

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
    </components.DropdownIndicator>
  );
};

const orderOptions = [
  { value: "MOST_RECENT", label: "Les plus récentes" },
  { value: "LEAST_RECENT", label: "Les moins récentes" },
  { value: "MOST_POPULAR", label: "Les plus populaires" },
  { value: "LEAST_POPULAR", label: "Les moins populaires" }
];

const ActivitiesOrderFilter = ({ setActivitiesOrder }) => {

  const handleSelectChange = (value) => {
    setActivitiesOrder(value.value);
  };

  return (
    <ReactSelect
      onChange={handleSelectChange}
      styles={newSeasonFilterStyle()}
      defaultValue={{ value: "MOST_RECENT", label: "Les plus récentes" }}
      options={orderOptions}
      components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
    />
  );
};

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter
});

const mapDispatchToProps = {
  setActivitiesOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesOrderFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/ActivitiesOrderFilter.js